// `__APP_VERSION__` is replaced at build time by Vite (see vite.config.ts).
// In dev it resolves to a timestamp generated when the dev server booted.
declare const __APP_VERSION__: string;

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";
